const en = {
  // en.js – Updated English (with Modified English where available)
  // tabs
  all: "All",
  pending: "Pending",
  underInvestigation: "Under Investigation",
  draftCharge: "Draft Charge",
  underLitigation: "Under Litigation",
  closed: "Closed",

  // table
  accusedProsecutor: "Accused Prosecutor",
  assignedTo: "Assigned To",
  appliedDate: "Applied Date",
  status: "Status",
  phoneNumber: "Phone Number",
  assign: "Assign",
  assigned: "Assigned",
  action: "Action",
  open: "Open",

  // Complaint List
  pageTitle: "Complaint Reception Requests",
  addNewComplaint: "Add New Complaint",
  tableTitle: "← Service Request Table",

  // New Complaint
  complaintFormTitle: "Complaint",
  complaintFormSubtitle: "Please fill the following details carefully.",
  selectAccusedProsecutor: "Select Accused Prosecutor",
  searchAccusedProsecutor: "Search Accused Prosecutor by Name",
  woreda: "Woreda",
  zone: "Zone",
  accusedProsecutorPhone: "Accused Prosecutor Phone",
  gender: "Gender",
  jobStatus: "Job Status",
  receptionDate: "Reception Date",
  dateOfOffense: "Date of Commission of Disciplinary Offense",
  disciplinaryOffenseType: "Disciplinary Offense Type",
  selectOffenseType: "Select Offense Type",
  offenseDescription: "Offense Description",
  describeIncident: "Describe the incident here",
  addComplaint: "Add Complaint",
  male: "Male",
  female: "Female",
  submissionError: "Submission error",
  successfullyCreated: "Successfully Created",
  successfullyUpdated: "Successfully Updated",
  successfullyConfirmed: "Successfully Confirmed",
  graveOffenseError: "grave offence is report above 4 years",
  mediumOffenseError: "medium for 3 years",
  pityOffenseError: "petty offence 2 years",
  dateRequired: "Date is required or invalid.",
  submitting: "Submitting",
  prosecutorOffenceRegion: "Prosecutor Offense Region",
  prosecutorOffenceZone: "Prosecutor Offense Zone",
  prosecutorOffenceWoreda: "Prosecutor Offense Woreda",

  // Complaint Detail
  complaintDetail: "Complaint Detail",
  detailInformation: "Detail Information",
  litigation: "Litigation",
  appeal: "Appeal",
  uploadChargeDocument: "Upload Charge Document",
  sendToRegistrar: "Send to Registrar",
  sendToCouncilOffice: "Send to Council Office",
  // sendToCouncilHead: "Send to Council Head",
  sendToRegionalCouncilHead: "Send to Regional Council Office Head",
  sendToZonalCouncilHead: "Send to Zonal Council Office Head",
  backToProsecutor: "Back to Prosecutor",
  backToCouncilOfficer: "Back to Inspection Directorate",
  approvedToCreateLetter: "Approve To Create Summon",
  createSummon: "Create Summon",
  createASummon: "Create a Summon",
  terminate: "Terminate",
  addInitialHearing: "Add Initial Hearing",
  addDailyHearing: "Add Daily Hearing",
  addLitigationDecision: "Add Litigation Decision",
  addCouncilOfficeDecision: "Add Council Office Decision",
  createAccusedAppeal: "Create Accused Appeal",
  updateAppeal: "Update Appeal",
  requestForAppeal: "Request For Appeal",
  appealRequest: "Appeal Request",
  sent: "Sent",
  failedToLoadComplaint: "Failed to load complaint.",
  failedToLoadInvestigation: "Failed to load investigation.",
  failedToLoadSummon: "Failed to load summon.",
  failedToLoadLitigation: "Failed to load litigation.",
  failedToLoadCouncilLitigation: "Failed to load council litigation.",
  failedToLoadAppeal: "Failed to load appeal.",
  failedToLoadAccusedSummon: "Failed to load accused summon.",
  investigationNotFound: "Investigation not found!",
  offenseType: "Offense Type",
  terminationReason: "Termination Reason",
  orderGivenBy: "Order Given By",
  terminationDoc: "Termination Doc",
  documentInformation: "Document Information",
  receivedBy: "Received by",
  registeredBy: "Registered by",
  decisionType: "Decision Type",
  decisionDay: "Decision Day",
  decisionSummary: "Decision Summary",
  evidenceInfo: "Evidence Info",
  assignedDate: "Assigned Date",
  publicProsecutorDecision: "Public Prosecutor Decision",
  unassigned: "Unassigned",
  reassignCase: "Reassign Case",
  prosecutorDecision: "Prosecutor Decision",
  noDate: "No date",
  furtherInvestigation: "Further Investigation",
  prosecutorDecisionSummary: "Prosecutor Decision Summary",
  prosecutorDecisionDocument: "Prosecutor Decision Document",
  feedbackType: "Feedback Type",
  hideFeedbacks: "Hide feedbacks",
  showAllFeedbacks: "Show all feedbacks",
  addFeedback: "Add Feedback",
  addFurtherInvestigation: "Add Further Investigation",
  addDecision: "Add Decision",
  chargeDocument: "Charge Document",
  registeredDate: "Registered Date",
  registeredNumber: "Registered Number",
  chargeSummary: "Charge Summary",
  articleOfCharge: "Article of Charge",
  chargeDoc: "Charge Doc",
  chargeFeedback: "Charge Feedback",
  councilChargeFeedback: "Council Charge Feedback",
  addRegistrationNo: "Add Registration No",
  updateChargeDoc: "Update Charge Doc",

  summon: "Summon",
  hearingDate: "Hearing Date",
  addressInformation: "Address Information",
  summary: "Summary",
  summonDoc: "Summon Doc",
  confirm: "Confirm",
  accusedProsecutorResponse: "Accused Prosecutor Response",
  letterDoc: "Letter Doc",
  addResponse: "Add Response",

  dailyReportSummary: "Daily Report Summary",
  appointmentReason: "Appointment Reason",
  attendances: "Attendances",
  member: "Member",
  present: "Present",
  wasPresent: "Was Present",
  yes: "Yes",
  no: "No",
  date: "Date",
  remark: "Remark",
  councilDecisionSummary: "Council Decision Summary",
  minuteFile: "Minute File",
  councilDecisionFile: "Council Decision File",
  terminationFile: "Termination File",
  addAttendance: "Add Attendance",
  officeOfCouncilDecision: "Office of Council Decision",
  submissionDate: "Submission Date",
  councilDecisionType: "Council Decision Type",
  decisionMeasureType: "Decision Measure Type",
  councilOrder: "Council Order",
  nextAppointmentDate: "Next Appointment Date",
  remainingDaysForAppeal: "Remaining Days for Appeal",
  day: "day",
  days: "days",
  prosecutorOpinionOnDecision: "Prosecutor Opinion On Decision",
  feedback: "Feedback",
  prosecutorOpinion: "Prosecutor Opinion",

  memorandumSummary: "Memorandum of Disciplinary Appeal Summary",
  memorandumDoc: "Memorandum of Disciplinary Appeal Doc",
  appealType: "Appeal Type",
  feedbackOnMemorandum: "Feedback on Memorandum",
  addFeedbackOnMemorandum: "Add Feedback on Memorandum",

  activityLogs: "Activity Logs",
  changedBy: "Changed By",
  actionType: "Action Type",
  fieldName: "Field Name",
  oldValue: "Old Value",
  newValue: "New Value",
  additionalInfo: "Additional Info",
  modelName: "Model Name",

  applicationNumber: "Application Number",
  accusedComplaintRequests: "Accused Complaint Requests",
  serviceRequestTable: "← Service Request Table",

  appealToGeneralCouncil: "Apepal to General Council",
  generalCouncilLitigation: "General Council Litigation",
  accusedComplaintDetail: "Accused Complaint Detail",
  sendToCouncil: "Send to Council",
  addAppealLitigationDecision: "Add Appeal Litigation Decision",
  appealToCourt: "Appeal to Court",
  summonNotFound: "Summon not found!",

  appealToCouncil: "Apepal to Council",
  councilLitigation: "Council Litigation",

  accusedSummon: "Accused Summon",
  registrationNumber: "Registration Number",
  registrationDate: "Registration Date",
  claimSummary: "Claim Summary",
  claimSummaryDoc: "Claim Summary Doc",
  letterUpload: "Letter Upload",
  responseSummary: "Response Summary",
  assignProsecutor: "Assign Prosecutor",

  confirmed: "Confirmed",
  confirmAccusedSummon: "Confirm Accused Summon",
  selectProsecutor: "Select Prosecutor",

  cannotFindSummon: "Can not find summon",
  canNotFindSummonOrAppealData: "Can not find summon or appeal data",
  noPermissionCreateDailyHearing:
    "You do not have permission to create daily hearing",
  addAccusedAppealDailyHearing: "Add Accused Appeal Daily Hearing",
  datePlaceholder: "Eg. June 12, 2014",
  givenOrder: "Given Order",
  detailsPlaceholder: "Details here...",
  uploadFiles: "Upload Files",
  addSummonRegistrationNo: "Add Summon Registration No.",
  registrationNo: "Registration No",
  registrationPlaceholder: "Eg. XX000001",
  submit: "Submit",
  accusedSummonNotFound: "Accused Summon not found!",
  responseFile: "Response File",
  complaintNotFound: "Complaint not found!",
  courtName: "Court Name",
  courtNumber: "Court Number",
  hearingCourt: "Hearing Court",
  courtOrderSummon: "Court Order Summon",
  courtSummonFile: "Court Summon File",

  accusedAdvocate: "Accused Advocate",
  licenseNumber: "License Number",
  emDash: "—",
  accusedAdvocateComplaintRequests: "Accused Advocate Complaint Requests",
  accused: "Accused",
  advocate: "Advocate",
  paralegal: "Paralegal",
  evidence: "Evidence",
  reporter: "Reporter",
  victim: "Victim",
  witness: "Witness",
  assignedProsecutor: "Assigned Prosecutor",
  hearingInformation: "Hearing Information",
  noClaimSummaryAvailable: "No claim summary available",
  documents: "Documents",
  responseDocument: "Response Document",
  reassignProsecutor: "Reassign Prosecutor",
  previouslyAssignedProsecutor: "Previously Assigned Prosecutor",
  name: "Name",
  userId: "User ID",
  verbalLitigation: "verbal litigation",
  evidenceInspection: "evidence inspection",
  evidenceDefence: "evidence defence",
  finalDecision: "final decision",
  createAccusedSummon: "Create Accused summon",
  hearingDatePlaceholder: "Eg. June 12, 2014",
  detailsHere: "Details here...",

  advocateAppealRequests: "Advocate Appeal Requests",
  councilAppeal: "Council Appeal",
  councilAppealLitigation: "Council Appeal Litigation",
  courtAppeal: "Court Appeal",
  courtAppealLitigation: "Court Appeal Litigation",
  appealDetail: "Appeal Detail",
  rejectAppeal: "Reject Appeal",
  createAppealSummon: "Create Appeal Summon",
  appealNotFound: "Appeal not found!",
  forwardedToRegistrar: "Forwarded to registrar",
  forwardedToCouncil: "Forwarded to council",
  generalCouncilAppeal: "General Council Appeal",
  generalCouncilAppealLitigation: "General Council Appeal Litigation",
  createGeneralCouncilAppealSummon: "Create General Council Appeal Summon",
  addCouncilDecision: "Add Council Decision",
  councilDecisionDate: "Council Decision Date",
  egJune122014: "Eg. June 12, 2014",
  selectDisciplineType: "Select Discipline Type",
  addAppealDailyHearing: "Add Appeal Daily Hearing",
  dailyHearingHistory: "Daily Hearing History",
  noDailyHearingHistoryFound: "No daily hearing history found!",
  youDoNotHavePermissionToCreateDailyHearing:
    "You do not have permission to create daily hearing",
  addCourtDecision: "Add Court Decision",
  prosecutorOpinionOnAppeal: "Prosecutor Opinion on Appeal",
  courtDecisionDate: "Court Decision Date",
  courtDecisionType: "Court Decision Type",
  selectDisciplineMeasure: "Select Discipline Measure",
  courtDecisionFile: "Court Decision File",
  addAppealSummonDecision: "Add Appeal Summon Decision",
  decisionFile: "Decision File",
  region: "Region",
  kebele: "Kebele",
  summonFile: "Summon File",
  addSummon: "Add Summon",
  uploadMemorandumOfDisciplinaryAppeal:
    "Upload Memorandum of Disciplinary Appeal",
  appealFromInspectionProsecutorToCouncilOffice:
    "Appeal from Inspection Prosecutor to Council Office",
  appealFromInspectionProsecutorToCourt:
    "Appeal from Inspection Prosecutor to Court",
  amendedMemorandumOfDisciplinaryAppealSummary:
    "Amended Memorandum of Disciplinary Appeal Summary",
  amendedMemorandumOfDisciplinaryAppealDoc:
    "Amended Memorandum of Disciplinary Appeal Doc",
  uploadMemorandum: "Upload Memorandum",
  compliantNotFound: "Compliant not found!",
  memorandumFileIsRequired: "Memorandum file is required",
  addChargeFeedback: "Add Charge Feedback",
  expired: "Expired",
  ago: "ago",
  dueToday: "Due today",
  dueTomorrow: "Due tomorrow",
  remaining: "remaining",
  appealDecision: "Appeal Decision",
  appealCouncilDecision: "Appeal Council Decision",
  finalDecisionRendered: "Final decision rendered by the appeal council",
  decisionDate: "Decision Date",
  measureType: "Measure Type",
  appealDeadlineStatus: "Appeal Deadline Status",
  deadline: "Deadline",
  advocateClaimSummary: "Advocate Claim Summary",
  decisionDocuments: "Decision Documents",
  appealHearingSession: "Appeal Hearing Session",
  decisionMade: "Decision Made",
  nextHearing: "Next Hearing",
  hearingDecisionSummary: "Hearing Decision Summary",
  hearingDocuments: "Hearing Documents",
  officialDecisionDocument: "Official decision document",
  caseTerminationDocument: "Case termination document",
  noAppealLitigationData: "No Appeal Litigation Data",
  noAppealLitigationMessage:
    "There are no appeal decisions or hearing records available for this case.",
  accusedResponse: "Accused Response",
  confirmAppealSummon: "Confirm Appeal Summon",
  summonConfirmedBy: "Summon Confirmed By",
  coordinator: "Coordinator",
  rejectComment: "Reject Comment",
  showDailyHearingHistory: "Show Daily Hearing History",
  institution: "Institution",
  noPermissionToTerminate: "You do not have permission to create daily hearing",
  terminateLitigation: "Terminate Litigation",

  advocateComplaintReceptionRequests: "Advocate Complaint Reception Requests",
  failedToLoadAdvocates: "Failed to load advocates.",
  failedToLoadDecisionTypes: "Failed to load decision types",
  failedToLoadMeasureTypes: "Failed to load measure types",
  receptionDateRequired: "Reception Date is Required.",
  offenseDateRequired: "Date of Offense is Required.",
  accusedAdvocateRequired: "Accused Advocate is Required.",
  pettyOffenseError:
    "Petty offenses must be reported within 2 years of occurrence.",
  newAdvocateComplaintRegistration: "New Advocate Complaint Registration",
  officialFormDescription:
    "Official form for registering disciplinary complaints against legal advocates. All fields marked with",
  areMandatory: "are mandatory",
  advocateInformation: "Advocate Information",
  advocateInformationDescription:
    "Select accused advocate and provide professional details",
  accusedAdvocateDescription:
    "Identify the legal advocate against whom the complaint is filed",
  isAccusationReportByMobile: "Is Accusation report By mobile?",
  accusationReportByMobileDescription:
    "Check if the accusation report was submitted via mobile application",
  reportApplicationNumber: "Report Application Number",
  reportApplicationNumberDescription:
    "Enter the report or application reference number",
  reportApplicationNumberPlaceholder: "e.g., APP-2024-00123",
  complaintType: "Complaint Type",
  advocateComplaint: "Advocate Complaint",
  paralegalComplaint: "Paralegal Complaint",
  complaintTypeDescription:
    "Select whether this complaint is against an advocate or a paralegal.",
  searchAdvocate: "Search Advocate",
  searchAdvocateDescription: "Enter name or license number",
  searchAdvocatePlaceholder: "Enter advocate name or license number...",
  searchingAdvocateRegistry: "Searching advocate registry...",
  license: "License",
  na: "N/A",
  noAdvocatesFound: "No advocates found matching",
  legalAdvocate: "Legal Advocate",
  phone: "Phone",
  caseDetails: "Case Details",
  caseDetailsDescription:
    "Provide comprehensive details about the complaint and disciplinary offense",
  basicInformation: "Basic Information",
  selectClassification: "-- Select Classification --",
  complaintReceptionDate: "Complaint Reception Date",
  dateOfAllegedOffense: "Date of Alleged Offense",
  fieldRequired: "This field is required",
  detailedOffenseDescription: "Detailed Offense Description",
  offenseDescriptionPlaceholder:
    "Enter detailed description of the alleged disciplinary offense. Be specific about dates, locations, individuals involved, ethical violations, and any supporting evidence...",
  characters: "Characters",
  returnToDashboard: "Return to Dashboard",
  clearAllFields: "Clear All Fields",
  processingSubmission: "Processing Submission...",
  submitAdvocateComplaint: "Submit Advocate Complaint",
  issueASummon: "Issue a Summon",
  reporters: "Reporters",
  victims: "Victims",
  witnesses: "Witnesses",
  summonIssued: "Summon Issued",
  hide: "Hide",
  show: "Show",
  approved: "Approved",
  claimSummaryFile: "Claim Summary File",
  addAccusedSummon: "Add Accused Summon",
  addMemorandumFeedback: "Add Memorandum Feedback",
  memorandumFileRequired: "Memorandum file is required",
  appealFromInspectionToCouncil:
    "Appeal from Inspection Prosecutor to Council Office",
  appealFromInspectionToCourt: "Appeal from Inspection Prosecutor to Court",
  memorandumDocument: "Memorandum of Disciplinary Appeal Document",
  somethingWentWrong: "Something went wrong.",
  addAppealRegistrationNo: "Add Appeal Registration No.",
  provideChargeSummary: "Please provide charge summary",
  provideArticleOfCharge: "Please provide article of charge",
  chargeDocumentFramed: "Charge document framed successfully",
  failedToFrameCharge: "Failed to frame charge document",
  frameChargeDocument: "Frame Charge Document",
  framingCharges: "Framing Charges",
  case: "Case",
  chargeSummaryPlaceholder: "Brief summary of the charges being framed...",
  articleOfChargePlaceholder:
    "Specific legal articles and provisions being charged...",
  clickToChange: "Click to change",
  clickToUploadOrDrag: "Click to upload or drag and drop",
  fileTypes: "PDF, DOC, DOCX up to 10MB",
  removeFile: "Remove File",
  cancel: "Cancel",
  addChargeRegistrationNo: "Add Charge Registration No.",
  prosecutorRequired: "Prosecutor is required",
  decisionCreated: "Decision successfully created",
  forwardToZone: "Forward to Zone",
  selectZone: "Select a zone",
  decisionSummaryPlaceholder: "Provide details about your decision...",
  processing: "Processing...",
  summonInformationNotFound: "Summon information not found",
  dailyHearingOfficiallyDocumented:
    "Daily hearing record has been officially documented",
  failedToDocumentDailyHearing: "Failed to document daily hearing",
  inspectionOfficeDailyHearing: "Inspection Office Daily Hearing",
  councilOfficeDailyHearing: "Council Office Daily Hearing",
  dailyHearingRecord: "Daily Hearing Record",
  hearingDetails: "Hearing Details",
  mustBeAfterTheHearingDate: "Must be after the hearing date",
  councilOrderInstruction: "Council Order/Instruction",
  enterOfficialCouncilOrdersOrInstructions:
    "Enter official council orders or instructions...",
  selectAppointmentReason: "Select appointment reason",
  finalHearingDecisionWarning:
    "This will be recorded as the final hearing decision",
  provideOfficialSummaryOfTodayProceedings:
    "Provide the official summary of today's proceedings...",
  minuteDocumentation: "Minute Documentation",
  uploadMeetingMinutes: "Upload Meeting Minutes",
  uploadOfficialMinutes: "Upload Official Minutes",
  documentHearing: "Document Hearing",
  dailyHearingRecordWillBeOfficiallyDocumented:
    "This hearing record will be officially documented in the litigation proceedings.",
  finalHearingDecisionConfirmation: "Final Hearing Decision Confirmation",
  finalHearingDecisionConfirmationMessage:
    "You are about to record this as the final hearing decision. This will conclude the litigation proceedings. Are you sure you want to proceed?",
  recordFinalDecision: "Yes, Record Final Decision",
  goBack: "No, Go Back",
  prosecutorDecisionRegistry: "Prosecutor Decision Registry",
  decisionDetails: "Decision Details",
  selectDecisionType: "Select decision type",
  outOfJurisdictionForwardToZone: "Out of jurisdiction forward to zone",
  forwardedToZoneForFurtherInvestigation:
    "Forwarded to zone for further investigation",
  selectZoneAdministration: "Select zone administration",
  caseWillBeTransferredToSelectedZonalAdministration:
    "Case will be transferred to the selected zonal administration",
  enterOfficialSummaryOfProsecutorDecision:
    "Enter the official summary of the prosecutor's decision...",
  uploadOfficialDecisionDocument: "Upload Official Decision Document",
  addEvaluation: "Add Evaluation",
  uploadSupportingDocuments: "Upload Supporting Documents",
  fileTypesWithMax10mb: "PDF, DOC, JPG, PNG files (Max 10MB)",
  selectedDocuments: "Selected Documents",
  submitProsecutorDecision: "Submit Prosecutor Decision",
  officialProsecutorialDeterminationNote:
    "This decision will be recorded as an official prosecutorial determination.",
  prosecutorDecisionRecorded: "Prosecutor decision has been formally recorded",
  failedToSubmitProsecutorDecision: "Failed to submit prosecutor decision",
  administrativeReviewDecision: "Administrative Review Decision",
  officialCaseManagementDetermination: "Official Case Management Determination",
  administrativeDetermination: "Administrative Determination",
  selectAdministrativeDecision: "Select administrative decision",
  nextCourseOfActionForCase:
    "This determines the next course of action for this case",
  provideOfficialReasoningForAdministrativeDecision:
    "Provide the official reasoning for this administrative decision...",
  assignInvestigator: "Assign Investigator",
  selectPublicProsecutor: "Select Public Prosecutor",
  assignedProsecutorWillConductOfficialInvestigation:
    "The assigned prosecutor will conduct the official investigation",
  cancelReview: "Cancel Review",
  processingDecision: "Processing Decision...",
  investigatorAssignmentRequiredForApproval:
    "Investigator assignment is required for approval",
  pleaseSelectZoneForForwarding: "Please select a zone for forwarding",
  decisionOfficiallyRecordedInSystem:
    "Decision has been officially recorded in the system",
  failedToProcessAdministrativeDecision:
    "Failed to process the administrative decision",
  forwardToZonalAdministration: "Forward to Zonal Administration",
  forwardToRegionalAdministration: "Forward to Regional Administration",
  approveAndAssignInvestigator: "Approve & Assign Investigator",
  rejectComplaint: "Reject Complaint",
  requestAdditionalInformation: "Request Additional Information",
  forwardToSelectedZone: "Forward to Selected Zone",
  forwardToRegional: "Forward to Regional",
  submitDecision: "Submit Decision",
  noPermissionToCreateDailyHearing:
    "You do not have permission to create daily hearing",
  selectDecisionDate: "Please select a decision date",
  provideDecisionSummary: "Please provide a decision summary",
  decisionAddedSuccessfully: "Prosecutor decision added successfully",
  failedToAddDecision: "Failed to add prosecutor decision",
  addProsecutorDecision: "Add Prosecutor Decision",
  characterCount: "Character count",
  chargeFile: "Charge File",
  uploadDecisionDocuments: "Upload Decision Documents",
  selectedFiles: "Selected Files",
  clearAll: "Clear All",
  supportingDocuments: "Supporting Documents",
  optional: "Optional",
  addingDecision: "Adding Decision...",
  addEvidence: "Add Evidence",
  collectedBy: "Collected By",
  collectedByPlaceholder: "Eg. Abebe Kebede",
  evidenceType: "Evidence Type",
  evidenceTypePlaceholder: "Eg. Document",
  collectionDate: "Collection Date",
  remarkPlaceholder: "Provide details...",
  evidenceFiles: "Evidence Files",
  fileTypesSimple: "PDF, JPG, PNG files",
  collectorNameRequired: "Collector name is required",
  evidenceTypeRequired: "Evidence type is required",
  collectionDateRequired: "Collection date is required",
  evidenceSuccessfullyAdded: "Evidence successfully added",
  failedToSubmitEvidence: "Failed to submit evidence",
  selectType: "Select type",
  documentary: "Documentary",
  digital: "Digital",
  physical: "Physical",
  other: "Other",
  addInitialHearingOnChargeDocument: "Add Initial Hearing on Charge Document",
  councilDecision: "Council Decision",
  isCouncilDecideInitialDay: "Is Council Decide Initial Day?",
  letterFileRequired: "Letter file is required",
  createLetter: "Create Summon",
  letterDocument: "Letter Document",
  sendSummonToo: "Send summon too?",
  addDailyHearingFeedback: "Add Daily Hearing Feedback",
  addReporter: "Add Reporter",
  fullName: "Full Name",
  fullNamePlaceholder: "Enter full name",
  phonePlaceholder: "+251-XXX-XXXXXX",
  email: "Email",
  emailPlaceholder: "email@example.com",
  address: "Address",
  addressPlaceholder: "Street address",
  locationDetails: "Location Details",
  city: "City",
  idNumber: "ID Number",
  idCard: "ID Card",
  uploadIdCard: "Upload ID Card",
  addSummonDecision: "Add Summon Decision",
  summonLetterNotFound: "Summon Letter not found!",
  uploadResponseFile: "Please upload a response file",
  addVictim: "Add Victim",
  addWitness: "Add Witness",
  registeredRegistrationDate: "Registered Registration Date",
  updateMemorandum: "Update Memorandum",
  latest: "Latest",
  noChargeDocumentUploaded: "No charge document uploaded",
  councilFeedback: "Council Feedback",
  latestVersion: "Latest Version",
  noSummaryAvailable: "No summary available",
  noArticleDetailsAvailable: "No article details available",
  documentHistory: "Document History",
  previousVersions: "previous versions",
  directorFeedback: "Director Feedback",
  feedbacks: "feedback(s)",
  addDirectorFeedback: "Add Director Feedback",
  successfullyForwardedToProsecutor: "Successfully forwarded to prosecutor",
  forwardToProsecutor: "Forward to Prosecutor",
  councilInitialDecision: "Council Initial Decision",
  initialDecision: "Initial Decision",
  decisionMadeOnInitialDay: "Decision made on initial day",
  initialDayDecision: "Initial Day Decision",
  noDecision: "No Decision",
  rejectCharge: "Reject Charge",
  chargeRejection: "Charge Rejection",
  councilRejectedCharge: "Council rejected the charge",
  rejected: "Rejected",
  rejectionDate: "Rejection Date",
  rejectionReason: "Rejection Reason",
  registerChargeDocument: "Register Charge Document",
  caseStatus: "Case Status",
  currentComplaintStatus: "Current complaint status",
  accusedLicenseNo: "Accused License No.",
  commissionOfDisciplinaryOffense: "Commission of Disciplinary Offense",
  additionalInformation: "Additional Information",
  allComplaintDetailsDisplayed: "All complaint details are displayed here",
  terminationDocument: "Termination Document",
  officialTerminationDocument: "Official termination document",
  decisionInformation: "Decision Information",
  active: "Active",
  latestDecision: "Latest Decision",
  current: "Current",
  outOfJurisdictionSource: "Out of Jurisdiction Source",
  previousDecisions: "Previous Decisions",
  decision: "Decision",
  collapseAll: "Collapse All",
  expandAll: "Expand All",
  noDecisionsMade: "No decisions have been made yet.",
  evidenceInformation: "Evidence Information",
  supportingEvidenceDocuments: "Supporting evidence documents",
  hearingTimeline: "Hearing Timeline",
  chronologicalRecordOfHearings: "Chronological record of all hearing sessions",
  hearing: "hearing",
  hearings: "hearings",
  hearingSession: "Hearing Session",
  next: "Next",
  order: "Order",
  noCouncilLitigationData: "No Council Litigation Data",
  noCouncilLitigationMessage:
    "There are no council decisions or hearing records available for this case.",
  finalDecisionRenderedByCouncil: "Final decision rendered by the council",
  prosecutorDecisions: "Prosecutor Decisions",
  decisions: "decision(s)",
  notAssignedYet: "Not assigned yet",
  noSummaryProvided: "No summary provided",
  chargeDocuments: "Charge Documents",
  noDecisionsYet: "No Decisions Yet",
  noProsecutorDecisionsMade:
    "No prosecutor decisions have been made for this case",
  evidenceDetails: "Evidence Details",
  collectedDate: "Collected Date",
  remarks: "Remarks",
  evidenceFile: "Evidence File",
  noEvidenceAdded: "No Evidence Added",
  addEvidenceToCase: "Add evidence to this case",
  noEvidenceRegistered: "No evidence have been registered for this case",
  unknownCollector: "Unknown Collector",
  noDescriptionProvided: "No description provided",
  evidenceDocuments: "Evidence Documents",
  noReportersAdded: "No Reporters Added",
  addReportersToCase: "Add reporters to this case",
  noReportersRegistered: "No reporters have been registered for this case",
  unnamedReporter: "Unnamed Reporter",
  idDocuments: "ID Documents",
  noVictimsAdded: "No Victims Added",
  addVictimsToCase: "Add victims to this case",
  noVictimsRegistered: "No victims have been registered for this case",
  unnamedVictim: "Unnamed Victim",
  idDocument: "ID Document",
  noWitnessesAdded: "No Witnesses Added",
  addWitnessesToCase: "Add witnesses to this case",
  noWitnessesRegistered: "No witnesses have been registered for this case",
  unnamedWitness: "Unnamed Witness",
  witnessDocuments: "Witness Documents",
  overdue: "Overdue",
  upcoming: "Upcoming",
  scheduled: "Scheduled",
  nextAppointment: "Next Appointment",
  prosecutor: "Prosecutor",
  appealDaysRemaining: "Appeal Days Remaining",
  rejectChargeDocument: "Reject Charge Document",
  comment: "Comment",
  emailAddress: "Email Address",
  completeAddress: "Complete Address",
  regionState: "Region/State",
  cityTown: "City/Town",
  close: "Close",
  reporterFile: "Reporter File",
  reporterInformationRecord: "Reporter Information Record",
  reporterDetails: "Reporter Details",
  notProvided: "Not provided",
  reporterLocation: "Reporter Location",
  identificationDocuments: "Identification Documents",
  reporterIdDocument: "Reporter ID Document",
  pdfDocument: "PDF Document",
  uploaded: "Uploaded",
  recorded: "Recorded",
  lastUpdated: "Last Updated",
  reporterRecord: "Reporter Record",
  officialRecord: "Official Record",
  closeFile: "Close File",
  hearingDatePassed: "Hearing date has passed",
  hearingIsToday: "Hearing is today",
  daysRemaining: "{days} days remaining",
  hearingSummon: "Hearing Summon",
  summonSummary: "Summon Summary",
  officialLetter: "Official Letter",
  summonDocument: "Summon Document",
  confirmSummon: "Confirm Summon",
  officialDocuments: "Official Documents",
  responseLettersAndCorrespondence:
    "Response letters and official correspondence",
  accusedAdvocateResponse: "Accused Advocate Response",
  officialResponseSubmission: "Official response submission",
  officialSummonLetter: "Official Summon Letter",
  governmentIssuedSummon: "Government-issued summon letter",
  submitAccusedAdvocateResponse: "Submit Accused Advocate Response",
  summonConfirmationStatus: "Summon Confirmation Status",
  overallStatus: "Overall Status",
  fullyConfirmed: "Fully Confirmed",
  partiallyConfirmed: "Partially Confirmed",
  prosecutorReassignedSuccessfully: "Prosecutor reassigned successfully",
  failedToReassignProsecutor: "Failed to reassign prosecutor",
  currentAssignment: "Current Assignment",
  currentlyAssignedProsecutor: "Currently assigned prosecutor",
  noProsecutorAssigned: "No prosecutor assigned",
  pleaseAssignProsecutor: "Please assign a prosecutor for this case",
  assignNewProsecutor: "Assign New Prosecutor",
  required: "Required",
  searchProsecutorsPlaceholder: "Search prosecutors by name...",
  advocateDisciplineProsecutor: "Advocate Discipline Prosecutor",
  selectFromList: "Select from list",
  chooseProsecutor: "Choose a prosecutor...",
  selectedProsecutor: "Selected Prosecutor",
  newAssignment: "New Assignment",
  willReplace: "Will replace",
  theCurrentAssignment: "the current assignment",
  note: "Note",
  reassignProsecutorNote:
    "This will reassign the prosecutor responsible for handling this case.",
  reassigning: "Reassigning...",
  confirmSubmissionTitle: "Confirm Submission",
  confirmSubmissionMessage:
    "Please review all entered information carefully. Once confirmed, this action will be submitted and cannot be modified.",
  search: "Search",
  noDataAvailable: "No data available.",
  rowsPerPage: "Rows per page:",
  of: "of",
  page: "Page",
  first: "First",
  prev: "Prev",
  last: "Last",
  attachment: "Attachment",
  thisFieldIsRequired: "This field is required",
  removeSelectedFile: "Remove selected file",
  uploadAFileHere: "Upload a file here",
  downloadFile: "Download File",
  view: "View",
  cannotConstructFileUrl: "Cannot construct file URL",
  failedToInitializeDocument: "Failed to initialize document",
  emptyFileReceived: "Empty file received",
  unknownError: "Unknown error",
  failedToLoadPdf: "Failed to load PDF",
  noFileUrlAvailableForDownload: "No file URL available for download",
  failedToDownloadFile: "Failed to download file",
  unknownDocument: "Unknown Document",
  minute: "Minute",
  loadingPdf: "Loading PDF...",
  pdfCouldNotBeLoaded: "PDF could not be loaded",
  openInNewTab: "Open in New Tab",
  downloadPdf: "Download PDF",
  pdfLoadedSuccessfully: "PDF loaded successfully",
  noFileUrl: "No file URL",
  failedToLoadImage: "Failed to load image",
  file: "File",
  unavailable: "Unavailable",
  download: "Download",
  created: "Created",
  loadingDocument: "Loading document...",
  errorLoadingDocument: "Error loading document",
  tryDownloadAnyway: "Try Download Anyway",
  failedToLoadVideo: "Failed to load video",
  browserDoesNotSupportVideo: "Your browser does not support the video tag.",
  failedToLoadAudio: "Failed to load audio",
  browserDoesNotSupportAudio: "Your browser does not support the audio tag.",
  fileCannotBePreviewed:
    "This file type cannot be previewed in the browser. Please download the file to view it.",
  closeModal: "Close modal",
  updated: "Updated",
  type: "Type",
  notifications: "Notifications",
  unread: "unread",
  noNewNotifications: "No new notifications",
  noNotifications: "No notifications",
  new: "NEW",
  newNotification: "New Notification",
  showing: "Showing",
  menuDashboardSection: "DASHBOARD",
  menuDashboard: "Dashboard",
  menuMainTask: "Main Task",
  menuReports: "Reports",
  menuProsecutor: "Prosecutor",
  menuComplaint: "Complaint",
  menuAppealedComplaint: "Appealed Complaint",
  menuAccusedAppeal: "Accused Appeal",
  menuCourtAppeal: "Court Appeal",
  loadingMenus: "Loading menus...",
  menuAdvocate: "Advocate",
  menuCompliant: "Compliant",
  menuAppealedCompliant: "Appealed Compliant",
  menuDiscipline: "Discipline",
  menuReportByMobile: "Report By Mobile",
  poweredByEaii: "Powered by EAII",
  logout: "Logout",
  brandOfficeName: "Biiroo Abba Alangaa W.O.",
  brandOfficeNameAm: "የኦሮሚያ ጠቅላይ ዐቃቤ ሕግ ቢሮ",
  uploadClaimFile: "Upload Claim File",
  upload: "Upload",
  updateChargeDocument: "Update Charge Document",
  update: "Update",
  victimFile: "Victim File",
  victimInformationRecord: "Victim Information Record",
  victimDetails: "Victim Details",
  victimLocation: "Victim Location",
  victimIdDocument: "Victim ID Document",
  victimRecord: "Victim Record",
  witnessStatementFile: "Witness Statement File",
  witnessInformationRecord: "Witness Information Record",
  witnessDetails: "Witness Details",
  witnessLocation: "Witness Location",
  witnessIdDocument: "Witness ID Document",
  statementRecorded: "Statement Recorded",
  witnessStatement: "Witness Statement",

  advocateCourtAppealRequests: "Advocate Court Appeal Requests",
  courtAppealDetail: "Court Appeal Detail",
  courtSummonNotFound: "Court Summon not found!",
  addCourtAppealDailyHearing: "Add Court Appeal Daily Hearing",
  reportType: "Report Type",
  isItFinalDecision: "Is it final decision?",
  successful: "Successful",
  courtAppealSummon: "Court Appeal Summon",
  appealDocuments: "Appeal Documents",
  noAppealDocumentsUploaded: "No appeal documents uploaded",
  courtDetails: "Court Details",
  courtHearingDate: "Court Hearing Date",
  courtOrder: "Court Order",
  sendToCoordinator: "Send to Coordinator",
  confirmCourtSummon: "Confirm Court Summon",

  disciplineManagement: "Discipline Management",
  baawoSystem: "B.A.A.W.O. System",
  loginTitle: "Login",
  authFormInstruction:
    "Please fill out this form carefully to start your daily task process and once you get the address you will be verified",
  emailLabel: "Email",
  passwordLabel: "Password",
  passwordPlaceholder: "Enter your password",
  newPasswordLabel: "New Password",
  newPasswordPlaceholder: "Enter your new password",
  confirmPasswordLabel: "Confirm Password",
  confirmPasswordPlaceholder: "Enter your password",
  registerAccountTitle: "Register Account",
  loading: "Loading...",
  loginButton: "Login",
  registerButton: "Register",
  invalidEmailOrPassword: "Invalid email or password",
  loginOfficeName: "Public Prosecutor Office",
  loginOfficeAddress: "Address information",
  dontHaveAccount: "Don't have an account?",
  alreadyHaveAccount: "Already have an account?",
  incidentListTitle: "Incident List",
  incidentCaseColumn: "Case",
  incidentTypeColumn: "Type",
  incidentStatusColumn: "Status",
  incidentDateColumn: "Date",
  incidentTypeRobbery: "Robbery",
  incidentTypeFraud: "Fraud",
  incidentTypeAssault: "Assault",
  incidentInformationTab: "Incident Information",
  evidenceFilesTab: "Evidence Files",
  suspectTab: "Suspect",
  victimsTab: "Victims",
  witnessesTab: "Witnesses",
  exhibitsTab: "Exhibits",
  screeningTab: "Screening",
  incidentDetailsInformationTitle: "Incident Details Information",
  incidentDetailsPlaceholder: "Lorem ipsum is a placeholder text...",
  incidentReportDate: "Incident Report Date",
  incidentDate: "Incident Date",
  crimeCategoryLabel: "Crime Category",
  receptionMethodLabel: "Reception Method",
  regionLabel: "Region",
  addressLabel: "Address",
  incidentReportedBy: "Incident Reported By",
  reporterAgeEducationCountry: "54 Yrs Old • Degree • Ethiopian",
  crimeNarrativeInfo: "Crime Narrative Info",
  evidenceOne: "Evidence one",
  evidenceTwo: "Evidence two",
  crimeInformationTitle: "Crime Information",
  suspectsListLabel: "Suspects List",
  suspectsListDesc: "2 individuals • Last updated date",
  victimListLabel: "Victim List",
  victimListDesc: "2 Victims • Both • Last updated date",
  evidenceListLabel: "Evidence List",
  evidenceListDesc: "3 Items • PDF • Last updated",
  exhibitItemsListLabel: "Exhibit Items List",
  exhibitItemsListDesc: "2 Items • Doc Files • Last updated",
  respondBackButton: "Respond Back",
  approveButton: "Approve",
  dashboardOverviewTitle: "Overview",
  dashboardOverviewDescription:
    "Monitor active work across the prosecution workflow, surface urgent queues, and keep track of major case-management scopes in one place.",
  dashboardActiveScopes: "active scopes",
  dashboardPriorityQueues: "priority queues",
  dashboardUpcomingMilestones: "upcoming milestones",
  dashboardOperationalSnapshot: "Operational snapshot",
  dashboardPriorityQueuesTitle: "Priority queues",
  dashboardPriorityQueuesDescription:
    "Immediate focus areas for coordinators, registrars, and prosecutors.",
  dashboardStatusCritical: "critical",
  dashboardStatusAttention: "attention",
  dashboardStatusStable: "stable",
  dashboardProjectScopeCoverage: "Project scope coverage",
  dashboardWorkloadAcrossModules: "Workload across major prosecution modules",
  dashboardScopes: "scopes",
  dashboardTotal: "total",
  dashboardInProgress: "In progress",
  dashboardOpenModule: "Open module",
  complainantName: "Complainant Name",
  complainantPhone: "Complainant Phone",
  accusedProsecutorName: "Accused Prosecutor Name",
  disciplineReportByMobile: "Discipline Report by Mobile",
  disciplineReportTable: "← Discipline Report Table",
  courtAppealRequests: "Court Appeal Requests",
  registerCouncilAttendanceTitle:
    "Register Plaintiff and Defendant Prosecutor attendance",
  namePlaceholder: "Name here...",

  appealRequests: "Appeal Requests",

  updateDate: "Update Date",
  evaluationDate: "Evaluation Date",
  viewEvaluation: "View Evaluation",
  submitAccusedResponse: "Submit Accused Response",

  evaluation: "Evaluation",
  workSpeedEvaluation: "Work Speed Evaluation",
  workQualityEvaluation: "Work Quality Evaluation",
  workLoadEvaluation: "Work Load Evaluation",
  noEvaluationsFound: "No evaluations found",
  reload: "Reload",
  // Prosecutor discipline dashboard
  pdDashboardTitle: "Dashboard",
  pdWelcomeBack: "Welcome back",
  pdOverviewAssigned: "Here is an overview of the discipline cases assigned to you.",
  pdOverviewUnit: "Here is an overview of prosecutor discipline cases in your administration unit.",
  pdOverviewAll: "Here is an overview of the prosecutor discipline cases you can see.",
  pdScopeAll: "All administration units",
  pdScopeAssigned: "My assigned cases",
  pdScopeUnit: "Administration unit",
  pdRangeAll: "All time",
  pdRange7: "Last 7 days",
  pdRange30: "Last 30 days",
  pdRange90: "Last 90 days",
  pdRangeYear: "This year",
  pdRangeCustom: "Custom range",
  pdFrom: "From",
  pdTo: "To",
  pdRefresh: "Refresh",
  pdLoading: "Loading...",
  pdTotalCases: "Total cases",
  pdTotalCasesHint: "All cases in this period",
  pdFromPrevious: "from previous period",
  pdOfTotal: "of all cases",
  pdYourQueue: "Your queue",
  pdStageReceived: "Received",
  pdStageReceivedHint: "New, returned or awaiting information",
  pdStageInvestigation: "Under investigation",
  pdStageInvestigationHint: "Assigned, investigating or drafting charge",
  pdStageCouncil: "At council",
  pdStageCouncilHint: "Summons, panel, litigation and verdict",
  pdStageAppeal: "Appealed",
  pdStageClosed: "Closed",
  pdStageClosedHint: "Closed, completed, terminated or rejected",
  pdStageOther: "Other",
  pdSummons: "Summons issued",
  pdCasesByStage: "Cases by stage",
  pdCaseTrend: "Case trend",
  pdLast6Months: "(last 6 months)",
  pdByOffence: "Cases by offence type",
  pdByDecision: "Decisions",
  pdUpcomingHearings: "Upcoming hearings (30 days)",
  pdRecentCases: "Recent cases",
  pdViewAll: "View all",
  pdNoData: "No data for this period",
  pdNoHearings: "No hearings in the next 30 days",
  pdNoRoleDashboard: "There is no prosecutor discipline dashboard for your role.",
  pdLoadFailed: "Failed to load dashboard data",
};

export default en;
